import { render, staticRenderFns } from "./RateForm.vue?vue&type=template&id=e6b19608&"
import script from "./RateForm.vue?vue&type=script&lang=js&"
export * from "./RateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports